export default __webpack_public_path__ + "dfd87f8fdfa585fbda7af6df87e05947.png";